/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { intelligentCustomerServiceComponent } from './intelligent-customer-service.component';

@NgModule({
    declarations: [intelligentCustomerServiceComponent],
    imports: [
        CommonModule,
        CoreModule,
    ],
    exports: [intelligentCustomerServiceComponent],
})
export class intelligentCustomerServiceModule { }
